var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.cartCount()
    ? _c(
        "div",
        { staticClass: "text-center pt-2" },
        [
          _c("CartSummary"),
          _vm.showButtons
            ? _c(
                "div",
                {
                  staticClass: "row align-items-center justify-content-bewteen",
                },
                [
                  _c(
                    "div",
                    { staticClass: "col-md-4 col-3" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass:
                            "action-button action-button-big-desktop d-flex justify-content-start",
                          attrs: { to: { name: "billing" } },
                        },
                        [
                          _c(
                            "a",
                            { staticClass: "main-btn d-none d-md-block" },
                            [_vm._v(_vm._s(_vm.capitalize(_vm.$t("back"))))]
                          ),
                          _c(
                            "a",
                            { staticClass: "main-btn back d-block d-md-none" },
                            [
                              _c("div", {
                                staticClass: "icon arrow-icon back-icon",
                              }),
                            ]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "col col-md-4 ml-md-auto" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-purple next-step w-100",
                        attrs: { type: "submit" },
                        on: { click: _vm.placeOrder },
                      },
                      [_c("b", [_vm._v(_vm._s(_vm.$t("btn_finish")))])]
                    ),
                  ]),
                ]
              )
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }